import React from "react";
import "./common-two-pane.css";
import SimpleSpinner from "../../../loader";
import SortIcon from "../../../../assets/svgs/SortIcon"
import { TextCss } from "../../../GlobalCss/TextCss";

export default function CommonTwoPaneView({
  title,
  sidebarTabs = [],
  activeTab,
  setActiveTab,
  addButtonLabel = "Add",
  onAdd,
  handleSort=()=>{},
  currentSortDirection="asc",
  loadingCombined = false,
  renderListForTab,
  hasAnyReports = true,
}) {
  return (
    <div className="common-two-pane-root">
      <div className="common-two-pane-main">
        <div className="common-two-pane-sidebar ">
          <div className={`${TextCss.black.heading_600_16} ps-2`}>{title}</div>
          <div className="sidebar-menu">
            {sidebarTabs.map((t) => (
              <div
                key={t.key}
                className={`sidebar-tab ${activeTab === t.key ? "active" : ""}`}
                onClick={() => setActiveTab(t.key)}
              >
                {t.label} ({t.count ?? 0})
              </div>
            ))}
          </div>
        </div>

        <div className="common-two-pane-content">
          {hasAnyReports && (
            <div className="template-content-header">
              <h2 className={TextCss.black.top_header_700_24}>{title}</h2>
              <div className="template-sort">
              <div className="sort-button" onClick={handleSort}>
              <span className="sort-text">
                {currentSortDirection === "asc"
                  ? "Sort by: A-Z"
                  : "Sort by: Z-A"}
              </span>
              <SortIcon classNames="iconStyleWithWhiteFilter"/>
              </div>
                  {onAdd && (
                    <button className="add-template-btn" onClick={onAdd}>
                      {addButtonLabel}
                    </button>
                  )}
              </div>

            </div>
          )}
          {renderListForTab(activeTab)}

          {/* {loadingCombined ? (
            <SimpleSpinner />
          ) : (
            <>
              {renderListForTab(activeTab)}
            </>
          )} */}
        </div>
      </div>
    </div>
  );
}
